import React, { Fragment, useRef } from "react";
import _ from "lodash";

import RegisterFields from "./RegisterFields";
import { externalRepairFields } from "./externalRepairFields";

export const ExternalRepairForm = (props) => {
  const renderFields = () => {
    return _.map(
      externalRepairFields,
      ({ label, name, type, options, required, description }) => {
        return (
          <RegisterFields
            key={name}
            name={name}
            label={label}
            type={type}
            options={options}
            required={required}
            initailValue={
              props.initialValues ? props.initialValues[name] : null
            }
            onChange={props.onChange(name)}
            disabled={props.disabled}
            description={description}
            viewonly={props.viewonly}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
